export const es = {
  brokerage: {
    loads: {
      title: 'Cargas Intermediadas',
      filters: {
        search: {
          aria: 'Buscar cargas intermediadas',
          placeholder: 'Buscar cargas...',
        },
        clearAll: 'Limpiar Todo',
      },
      toolbar: {
        create: 'Crear Carga',
        void: 'Anular',
        selected: 'seleccionados',
      },
      table: {
        aria: 'Lista de cargas intermediadas',
        columns: {
          expectedShipDate: 'Fecha Estimada de Envio',
          loadNumber: 'Carga #',
          supplier: 'Proveedor',
          brokeredOrder: 'Orden Intermediada',
          salesOrderNumber: 'Orden de Venta',
          lineItemCount: 'Articulos',
          netQuantity: 'Cant. Neta',
          shippedTotal: 'Total Enviado',
          status: 'Estado',
          shippedDate: 'Fecha de Envio',
          createdOn: 'Creado',
        },
      },
      emptyState: {
        title: 'Sin cargas intermediadas',
        subtitle:
          'Haz clic en Crear Carga para crear tu primera carga intermediada.',
        action: 'Crear Carga',
      },
      columnFilters: {
        dateRange: {
          label: 'Rango de Fechas',
          aria: 'Filtrar por rango de fechas',
          clear: 'Limpiar',
          done: 'Listo',
        },
        facility: {
          searchPlaceholder: 'Buscar instalaciones...',
        },
        supplier: {
          searchPlaceholder: 'Buscar proveedores...',
        },
        status: {
          searchPlaceholder: 'Buscar estados...',
        },
      },
      emptyResultsState: {
        title: 'No se encontraron resultados',
        subtitle: 'Intenta ajustar tu busqueda o filtros.',
        action: (filter?: string) =>
          filter ? `Limpiar "${filter}"` : 'Limpiar Filtros',
      },
      content: {
        error: (message: string) =>
          `Error al cargar las cargas intermediadas: ${message}`,
      },
      actions: {
        view: 'Ver',
        markAsShipped: 'Marcar como Enviada',
        markAsReceived: 'Marcar como Recibida',
        reconcile: 'Conciliar',
        void: 'Anular',
        actions: 'Acciones',
      },
      messages: {
        createSuccess: 'Carga intermediada creada exitosamente',
        createError: 'Error al crear la carga intermediada',
        updateSuccess: 'Carga intermediada actualizada exitosamente',
        updateError: 'Error al actualizar la carga intermediada',
        documentNumberError: 'Error al obtener el numero de carga',
        changesDiscarded: 'Cambios descartados',
        shippedSuccess: 'Carga marcada como enviada',
        receivedSuccess: 'Carga marcada como recibida',
        reconciledSuccess: 'Carga conciliada exitosamente',
        voidSuccess: (loadNumber: string) =>
          `Carga ${loadNumber} anulada exitosamente`,
      },
      dialogs: {
        common: {
          cancel: 'Cancelar',
        },
        shipped: {
          title: 'Marcar como Enviada',
          shippedDate: 'Fecha de Envio',
          lightWeight: 'Peso Ligero',
          heavyWeight: 'Peso Pesado',
          confirm: 'Marcar como Enviada',
        },
        received: {
          title: 'Marcar como Recibida',
          receivedDate: 'Fecha de Recepcion',
          confirm: 'Marcar como Recibida',
        },
        void: {
          title: 'Anular Carga',
          message: (loadNumber: string) =>
            `¿Estas seguro de que deseas anular la carga ${loadNumber}? Esta accion no se puede deshacer.`,
          confirm: 'Anular Carga',
        },
      },
      create: {
        title: 'Crear Carga Intermediada',
        cancel: 'Cancelar',
        submit: 'Crear Carga',
        wizard: {
          steps: {
            shipmentInfo: 'Info de Envio',
            materials: 'Materiales',
          },
          buttons: {
            back: 'Atras',
            next: 'Siguiente',
          },
        },
        fields: {
          loadNumber: 'Carga #',
          supplier: 'Proveedor',
          brokeredOrder: 'Orden Intermediada',
          expectedShipDate: 'Fecha Estimada de Envio',
          facility: 'Instalacion',
          salesOrder: 'Orden de Venta',
          booking: 'Reserva',
        },
        validation: {
          supplierRequired: 'El proveedor es requerido',
          facilityRequired: 'La instalacion es requerida',
          expectedShipDateRequired: 'La fecha estimada de envio es requerida',
        },
      },
      detail: {
        title: (loadNumber: string) => `Carga ${loadNumber}`,
        created: 'Creado',
        tabs: {
          loadInfo: 'Info de Carga',
          materials: 'Materiales',
          photos: 'Fotos',
          documents: 'Documentos',
          notes: 'Notas',
        },
        sections: {
          basicInfo: 'Informacion Basica',
          carrierInfo: 'Informacion del Transportista',
          notes: 'Notas',
        },
        fields: {
          supplier: 'Proveedor',
          brokeredOrder: 'Orden Intermediada #',
          expectedShipDate: 'Fecha Estimada de Envio',
          shippedWeights: 'Pesos Enviados',
          facility: 'Instalacion',
          salesOrder: 'Orden de Venta Relacionada #',
          booking: 'Reserva #',
          deliveryNumber: 'Entrega #',
          releaseNumber: 'Liberacion #',
          containerNumber: 'Contenedor #',
          sealNumber: 'Sello #',
          truckNumber: 'Camion #',
          trailerNumber: 'Remolque #',
        },
        footer: {
          materialsCount: (length: number): string =>
            length > 1 ? 'materiales' : 'material',
          discard: 'Descartar',
          saveUpdates: 'Guardar Cambios',
        },
        materials: {
          aria: 'Lista de materiales de la carga',
          columns: {
            material: 'Materiales',
            purchaseOrder: 'Orden de Compra',
            quantity: 'Cantidad',
            unitPrice: 'Precio Unitario',
            pricingUnit: 'Unidad',
            gross: 'Bruto',
            tare: 'Tara',
            net: 'Neto',
            requestedWeight: 'Peso Solicitado',
          },
          addMaterial: 'Agregar Material',
          addAllFromRequested: 'Agregar Todos los Solicitados',
          addAllFromSalesOrder: 'Agregar Todos de la Orden de Venta',
          emptyTitle: 'Sin materiales',
          emptyDescription: 'Agrega materiales a esta carga',
          emptyShippedTitle: 'Sin materiales enviados',
          emptyShippedDescription: 'Agrega materiales enviados a esta carga',
          selectMaterial: 'Seleccionar material',
          selectPurchaseOrder: 'Seleccionar orden de compra',
          netWeight: 'Peso Neto',
          totalGross: 'Total Bruto',
          totalTare: 'Total Tara',
          totalNet: 'Total Neto',
          totalValue: 'Valor Total',
          phases: {
            requested: 'Solicitado',
            shipped: 'Enviado',
          },
        },
        photos: {
          empty: 'No se han subido fotos',
        },
        documents: {
          empty: 'No se han subido documentos',
        },
        notes: {
          internalNotes: 'Notas Internas',
          externalNotes: 'Notas Externas',
        },
      },
    },
  },

  common: {
    actions: {
      cancel: 'Cancelar',
      create: 'Crear',
      save: 'Guardar',
      delete: 'Eliminar',
      edit: 'Editar',
      void: 'Anular',
      add: 'Agregar',
      link: 'Vincular',
      back: 'Atras',
      discard: 'Descartar',
    },
    status: {
      active: 'Activo',
      inactive: 'Inactivo',
      pending: 'Pendiente',
      voided: 'Anulado',
      open: 'Abierto',
      inProgress: 'En Progreso',
      draft: 'Borrador',
      closed: 'Cerrado',
      fulfilled: 'Cumplido',
      sent: 'Enviado',
      accepted: 'Aceptado',
      rejected: 'Rechazado',
      expired: 'Expirado',
      converted: 'Convertido',
      default: 'Predeterminado',
    },
    loading: {
      creating: 'Creando...',
      saving: 'Guardando...',
      linking: 'Vinculando...',
      adding: 'Agregando...',
      converting: 'Convirtiendo...',
    },
    selected: 'seleccionados',
    errors: {
      loading: (entity: string, message: string) =>
        `Error al cargar ${entity}: ${message}`,
      notFound: (entity: string) => `${entity} no encontrado`,
      unknown: 'Ocurrio un error desconocido',
    },
    labels: {
      notes: 'Notas',
      noNotes: 'Sin notas',
      name: 'Nombre',
      status: 'Estado',
      created: 'Creado',
      item: 'Articulo',
      quantity: 'Cantidad',
      unit: 'Unidad',
      items: 'Articulos',
      description: 'Descripcion',
    },
    placeholders: {
      generateNumber: 'Generar número',
      optionalNotes: 'Notas opcionales...',
      optionalDescription: 'Descripcion opcional...',
      searchAccount: 'Buscar una cuenta...',
      selectItem: 'Buscar un articulo...',
    },
    sections: {
      additionalInfo: 'Informacion Adicional',
    },
  },

  orders: {
    toolbar: {
      markAsFinished: 'Marcar como Finalizada',
      void: 'Anular',
    },
    wizard: {
      steps: {
        contractInfo: 'Info del Contrato',
        materials: 'Materiales',
      },
      buttons: {
        back: 'Atras',
        next: 'Siguiente',
      },
    },
    materials: {
      title: 'Materiales',
      empty: 'Sin materiales',
      emptyDescription:
        'Agrega materiales para definir los precios de la orden.',
      addButton: 'Agregar Material',
      emptyState: {
        title: 'Aun no se han agregado materiales',
        description:
          'Agrega materiales para definir los precios y cantidades de la orden.',
      },
      buttons: {
        addMaterial: 'Agregar Material',
        addFromOrders: 'Agregar Desde Ordenes de Compra y Venta',
      },
      columns: {
        material: 'Material',
        quantity: 'Cantidad',
        unit: 'Unidad',
        purchasePrice: 'Precio de Compra',
        salesPrice: 'Precio de Venta',
        avgPurchase: 'Compra Promedio',
        avgSale: 'Venta Promedio',
        margin: 'Margen',
        buyUnitPrice: 'Precio de Compra',
        buyUnitPriceSubheader: 'Por Unidad',
        sellUnitPrice: 'Precio de Venta',
        sellUnitPriceSubheader: 'Por Unidad',
        buyRequested: 'Compra Solicitada',
        receivedWeight: 'Recibido',
        buyRemaining: 'Compra Restante',
        sellRequested: 'Venta Solicitada',
        shippedWeight: 'Enviado',
        remainingTotal: 'Restante',
        buyTotal: 'Total de Compra',
        sellTotal: 'Total de Venta',
        estimatedProfit: 'Ganancia Est.',
      },
      fields: {
        item: 'Articulo',
        quantity: 'Cantidad',
        unit: 'Unidad',
        purchasePrice: 'Precio de Compra',
        salesPrice: 'Precio de Venta',
        purchaseTotal: 'Total de Compra',
        salesTotal: 'Total de Venta',
        margin: 'Margen',
        notes: 'Notas',
        actions: 'Acciones',
      },
      totals: {
        material: 'Materiales',
        totalMaterial: (count: number) =>
          `${count} ${count === 1 ? 'material' : 'materiales'}`,
        totalWeight: 'Cantidad Total',
        totalBuy: 'Total de Compra',
        totalSell: 'Total de Venta',
        totalMargin: 'Margen Total',
      },
      placeholders: {
        selectMaterial: 'Seleccionar material...',
        selectItem: 'Seleccionar articulo...',
        notes: 'Notas opcionales para este material...',
      },
      footer: {
        subtotal: 'Subtotal',
        itemCount: (count: number) =>
          `${count} ${count === 1 ? 'articulo' : 'articulos'}`,
      },
      toast: {
        added: 'Material agregado',
        updated: 'Material actualizado',
        deleted: 'Material eliminado',
      },
    },
    list: {
      title: 'Ordenes Intermediadas',
      search: 'Buscar ordenes...',
      ariaLabel: 'Lista de ordenes intermediadas',
      createButton: 'Crear Orden',
      empty: {
        title: 'No se encontraron ordenes intermediadas',
        description:
          'Crea tu primera orden intermediada para comenzar a rastrear margenes entre ordenes de compra y venta.',
      },
    },
    detail: {
      title: 'Orden Intermediada',
      orderTitle: (orderNumber: string) => `Orden ${orderNumber}`,
      createdAt: 'Creado el',
      backButton: 'Volver a Ordenes',
      tabs: {
        overview: 'Resumen',
        materials: 'Materiales',
        linkedOrders: 'Ordenes de Compra y Venta',
        notes: 'Notas',
      },
      sections: {
        orderInfo: 'Informacion de la Orden',
        parties: 'Partes',
        financials: 'Financieros',
      },
      fields: {
        orderNumber: 'Numero de Orden',
        status: 'Estado',
        item: 'Articulo',
        quantity: 'Cantidad',
        supplier: 'Proveedor',
        customer: 'Cliente',
        purchaseTotal: 'Total de Compra',
        salesTotal: 'Total de Venta',
        margin: 'Margen',
        marginPercent: '% de Margen',
      },
      linkedOrders: {
        purchaseOrders: 'Ordenes de Compra Vinculadas',
        salesOrders: 'Ordenes de Venta Vinculadas',
        noPurchaseOrders: 'Sin ordenes de compra vinculadas',
        noSalesOrders: 'Sin ordenes de venta vinculadas',
        linkPurchaseOrder: 'Vincular Orden de Compra',
        linkSalesOrder: 'Vincular Orden de Venta',
        searchPlaceholder: 'Buscar ordenes...',
        purchaseOrdersCount: (count: number) => `Ordenes de Compra (${count})`,
        salesOrdersCount: (count: number) => `Ordenes de Venta (${count})`,
        noPurchaseOrdersFound: 'No se encontraron ordenes de compra',
        noSalesOrdersFound: 'No se encontraron ordenes de venta',
        selectOrderToView: 'Selecciona una orden para ver los detalles',
        noOrders: 'Sin ordenes vinculadas',
        noOrdersDescription:
          'Vincula ordenes de compra o venta para rastrear esta transaccion intermediada.',
      },
      actions: {
        edit: 'Editar',
        openOrder: 'Abrir Orden',
        voidOrder: 'Anular Orden',
        finishOrder: 'Finalizar Orden',
        revertToOpen: 'Revertir a Abierta',
        printPackingLists: 'Imprimir Listas de Empaque',
        printBillsOfLading: 'Imprimir Conocimientos de Embarque',
        downloadPackingLists: 'Descargar Listas de Empaque',
        downloadBillsOfLading: 'Descargar Conocimientos de Embarque',
        viewPurchaseOrder: 'Ver Orden de Compra',
        viewSalesOrder: 'Ver Orden de Venta',
      },
      footer: {
        discard: 'Descartar',
        saveUpdates: 'Guardar Cambios',
      },
      unsavedDataMessage:
        'Tienes cambios sin guardar. ¿Estas seguro de que deseas salir?',
    },
    create: {
      title: 'Crear Orden Intermediada',
      description:
        'Crea una nueva orden intermediada para rastrear margenes entre ordenes de compra y venta.',
      sections: {
        orderDetails: 'Detalles de la Orden',
      },
      submitButton: 'Crear Orden',
    },
    edit: {
      title: 'Editar Orden Intermediada',
      sections: {
        orderInfo: 'Informacion de la Orden',
        parties: 'Partes',
        itemDetails: 'Detalles del Articulo',
        pricing: 'Precios',
      },
      fields: {
        orderNumber: 'Numero de Orden',
        supplier: 'Proveedores',
        customer: 'Clientes',
      },
      submitButton: 'Guardar Cambios',
    },
    link: {
      title: {
        purchaseOrder: 'Vincular Ordenes de Compra',
        salesOrder: 'Vincular Ordenes de Venta',
      },
      searchPlaceholder: 'Buscar por numero de orden...',
      filterByAccount: 'Filtrar por cuenta...',
      createSalesOrder: 'Crear Orden de Venta',
      createPurchaseOrder: 'Crear Orden de Compra',
      clearSelection: 'Limpiar',
      availableOrders: (type: 'purchase' | 'sales') =>
        `Ordenes de ${type === 'purchase' ? 'Compra' : 'Venta'} Disponibles`,
      noOrders: 'No hay ordenes disponibles para vincular',
      ordersSelected: (count: number) => `${count} orden(es) seleccionada(s)`,
      submitButton: (count: number) =>
        `Vincular ${count > 0 ? count : ''} Orden${count !== 1 ? 'es' : ''}`,
    },
    table: {
      columns: {
        orderNumber: 'Orden #',
        status: 'Estado',
        supplier: 'Proveedor',
        customer: 'Cliente',
        lineItems: 'Articulos',
        purchase: 'Compra',
        sales: 'Venta',
        margin: 'Margen',
      },
    },
    toast: {
      created: 'Orden intermediada creada exitosamente',
      updated: 'Orden intermediada actualizada exitosamente',
      voided: 'Orden intermediada anulada exitosamente',
      opened: 'Orden intermediada abierta exitosamente',
      finished: 'Orden intermediada finalizada exitosamente',
      reverted: 'Orden intermediada revertida a abierta',
      discarded: 'Cambios descartados',
      comingSoon: 'Esta funcionalidad estara disponible pronto',
      linkSuccess: (count: number, type: 'purchase' | 'sales') =>
        `${count} orden(es) de ${type === 'purchase' ? 'compra' : 'venta'} vinculada(s) exitosamente`,
      createError: (error: string) => `Error al crear la orden: ${error}`,
      updateError: (error: string) => `Error al actualizar la orden: ${error}`,
      voidError: (error: string) => `Error al anular la orden: ${error}`,
      openError: (error: string) => `Error al abrir la orden: ${error}`,
      finishError: (error: string) => `Error al finalizar la orden: ${error}`,
      revertError: (error: string) => `Error al revertir la orden: ${error}`,
      linkError: (error: string) => `Error al vincular las ordenes: ${error}`,
      materialRequired: 'Por favor selecciona un material para cada articulo',
    },
    validation: {
      validPurchasePrice: 'Por favor ingresa un precio de compra valido',
      validSalesPrice: 'Por favor ingresa un precio de venta valido',
      selectOrder: 'Por favor selecciona al menos una orden',
      badge: {
        valid: 'Valido',
        invalid: 'Invalido',
      },
      button: {
        validate: 'Validar Orden',
        validating: 'Validando...',
      },
      errors: {
        ITEM_NOT_IN_SALES_ORDERS:
          'el articulo no esta en ninguna orden de venta vinculada',
        ITEM_NOT_IN_PURCHASE_ORDERS:
          'el articulo no esta en ninguna orden de compra vinculada',
        INSUFFICIENT_PO_QUANTITY:
          'cantidad insuficiente en las ordenes de compra vinculadas',
      },
      section: {
        title: 'Validacion',
        issues: 'Problemas de Validacion',
      },
    },
  },

  quotes: {
    types: {
      sales: 'Cotizacion de Venta',
      purchase: 'Cotizacion de Compra',
      salesShort: 'Venta',
      purchaseShort: 'Compra',
      selling: 'Vendiendo',
      buying: 'Comprando',
    },
    list: {
      title: 'Cotizaciones',
      search: 'Buscar cotizaciones...',
      ariaLabel: 'Lista de cotizaciones',
      createButton: 'Crear Cotizacion',
      filters: {
        allStatuses: 'Todos los Estados',
        allFacilities: 'Todas las Instalaciones',
        clearAll: 'Limpiar Todo',
      },
      empty: {
        title: 'No se encontraron cotizaciones',
        description:
          'Crea cotizaciones de compra o venta para enviar a proveedores o clientes.',
      },
      emptyResults: {
        title: 'No se encontraron resultados',
        description: 'Intenta ajustar tu busqueda o filtros.',
      },
    },
    detail: {
      title: 'Cotizacion',
      quoteTitle: (type: string, quoteNumber: string) =>
        `Cotizacion ${type} ${quoteNumber}`,
      salesOrder: 'Venta',
      purchaseOrder: 'Compra',
      backButton: 'Volver a Cotizaciones',
      tabs: {
        overview: 'Info de Cotizacion',
        lineItems: 'Materiales',
        notes: 'Notas',
      },
      sections: {
        quoteInfo: 'Info de Cotizacion',
        paymentInfo: 'Info de Pago',
      },
      notes: {
        placeholder: 'Agrega notas sobre esta cotizacion...',
      },
      fields: {
        quoteNumber: 'Numero de Cotizacion',
        type: 'Tipo',
        status: 'Estado',
        validUntil: 'Valida Hasta',
        accountName: 'Nombre',
        facility: 'Instalacion',
        subtotal: 'Subtotal',
        paymentCurrency: 'Moneda de Pago',
        paymentTerm: 'Termino de Pago',
        shipmentTerm: 'Termino de Envio',
        freightCoveredByCustomer: 'Flete cubierto por el Cliente',
        lineItems: 'Articulos',
      },
      actions: {
        edit: 'Editar',
        markInReview: 'Marcar en Revision',
        markApproved: 'Marcar como Aprobada',
        markRejected: 'Marcar como Rechazada',
        revertToOpen: 'Revertir a Abierta',
        createSalesOrder: 'Crear OV',
        createPurchaseOrder: 'Crear OC',
        cloneQuote: 'Clonar',
        print: 'Imprimir',
        download: 'Descargar',
        send: 'Enviar',
        delete: 'Eliminar',
        void: 'Anular',
        restore: 'Restaurar',
        viewSalesOrder: 'Ver Orden de Venta',
      },
      footer: {
        discard: 'Descartar',
        saveUpdates: 'Guardar Cambios',
      },
      unsavedDataMessage:
        'Tienes cambios sin guardar. ¿Estas seguro de que deseas salir?',
    },
    create: {
      title: 'Crear Cotizacion',
      titleWithType: (type: string) => `Crear ${type}`,
      sections: {
        quoteDetails: 'Detalles de la Cotizacion',
      },
      fields: {
        quoteType: 'Tipo de Cotizacion',
        account: 'Cuenta',
        customerName: 'Nombre del Cliente',
        facility: 'Instalacion',
        validUntil: 'Valida Hasta',
        shipDate: 'Fecha Estimada de Envio',
        terms: 'Terminos',
      },
      placeholders: {
        terms: 'Terminos de pago, terminos de entrega, etc...',
      },
      submitButton: 'Crear Cotizacion',
    },
    edit: {
      title: 'Editar Cotizacion',
      sections: {
        quoteInfo: 'Informacion de la Cotizacion',
        validity: 'Validez',
      },
      fields: {
        quoteNumber: 'Numero de Cotizacion',
        account: 'Cuenta',
        validUntil: 'Valida Hasta',
        shipDate: 'Fecha Estimada de Envio',
        terms: 'Terminos',
      },
      placeholders: {
        selectAccount: 'Seleccionar cuenta...',
        terms: 'Terminos de pago, terminos de entrega, etc...',
      },
      submitButton: 'Guardar Cambios',
    },
    clone: {
      title: (quoteNumber: string, type: string) =>
        `Clonar Cotizacion ${type} ${quoteNumber}`,
      steps: {
        customers: 'Clientes',
        summary: 'Resumen',
      },
      searchPlaceholder: 'Buscar...',
      searchAriaLabel: 'Buscar cuentas',
      noAccounts: 'No se encontraron cuentas',
      summaryBanner: (count: number) =>
        `Despues de confirmar esta accion, **${count} ${count === 1 ? 'Cotizacion' : 'Cotizaciones'}** seran generadas automaticamente **por cada Cliente**.`,
      summaryFields: {
        facility: 'Instalacion',
        deadline: 'Fecha Limite',
        totalValue: 'Valor Total',
        materials: 'Materiales',
        materialsCount: (count: number) =>
          `${count} ${count === 1 ? 'Material' : 'Materiales'}`,
        customers: 'Clientes',
      },
      buttons: {
        next: 'Siguiente',
        back: 'Atras',
        clone: 'Clonar',
      },
      noFacility: 'Sin instalacion',
      noDeadline: 'Sin fecha limite',
      noMaterials: 'Sin materiales',
      unknownItem: 'Desconocido',
    },
    convert: {
      approveTitle: 'Aprobar y Cerrar Cotizacion?',
      approveMessage: (orderType: string) =>
        `La cotizacion se cerrara y una ${orderType} sera generada automaticamente. Desea continuar?`,
      approveConfirm: (abbreviation: string) =>
        `Aprobar y Crear ${abbreviation}`,
      approveCancel: 'Descartar',
      orderTypes: {
        salesOrder: 'Orden de Venta',
        purchaseOrder: 'Orden de Compra',
        salesOrderShort: 'OV',
        purchaseOrderShort: 'OC',
      },
    },
    lineItems: {
      title: {
        add: 'Agregar Articulo',
        edit: 'Editar Articulo',
      },
      sections: {
        itemDetails: 'Detalles del Articulo',
        pricing: 'Precios',
      },
      fields: {
        item: 'Materiales',
        packageFormat: 'Formato de Empaque',
        quantity: 'Peso Neto',
        unit: 'Unidad de Precio',
        unitPrice: 'Precio Unitario',
        total: 'Precio Total Est.',
        currency: 'Moneda',
        actions: 'Acciones',
      },
      placeholders: {
        selectItem: 'Seleccionar articulo...',
        notesForLineItem: 'Notas opcionales para este material...',
      },
      empty: 'Sin materiales',
      emptyDescription:
        'Agrega materiales para definir los precios de la cotizacion.',
      addButton: 'Agregar Material',
      totals: {
        material: 'Materiales',
        totalWeight: 'Peso Total',
        estimatedTotal: 'Total Est.',
      },
      footer: {
        subtotal: 'Subtotal',
        itemCount: (count: number) =>
          `${count} ${count === 1 ? 'articulo' : 'articulos'}`,
      },
      submitButton: {
        add: 'Agregar Articulo',
        save: 'Guardar Cambios',
      },
    },
    table: {
      columns: {
        quoteNumber: 'Cotizacion #',
        type: 'Tipo',
        status: 'Estado',
        account: 'Cuenta',
        customer: 'Cliente',
        facility: 'Instalacion',
        totalMaterials: 'Total de Materiales',
        totalWeight: 'Peso Total',
        totalValue: 'Valor Total',
        truckloads: 'Camiones',
        quoteDeadline: 'Fecha Limite de Cotizacion',
        shipDate: 'Fecha Est. de Envio',
        notes: 'Notas',
        items: 'Articulos',
        subtotal: 'Subtotal',
        validUntil: 'Valida Hasta',
        created: 'Creado',
      },
    },
    voidDialog: {
      title: 'Anular Cotizacion',
      message: (quoteNumber: string) =>
        `¿Estas seguro de que deseas anular la cotizacion ${quoteNumber}?`,
      confirm: 'Anular',
      cancel: 'Cancelar',
    },
    deleteDialog: {
      title: 'Eliminar Cotizacion',
      titleBulk: (count: number) =>
        `Eliminar ${count} ${count === 1 ? 'Cotizacion' : 'Cotizaciones'}`,
      message: (quoteNumber: string) =>
        `¿Estas seguro de que deseas eliminar la cotizacion ${quoteNumber}? Esta accion no se puede deshacer.`,
      messageBulk: (count: number) =>
        `¿Estas seguro de que deseas eliminar ${count} ${count === 1 ? 'cotizacion' : 'cotizaciones'}? Esta accion no se puede deshacer.`,
      confirm: 'Eliminar',
      confirmBulk: (count: number) =>
        `Eliminar ${count} ${count === 1 ? 'Cotizacion' : 'Cotizaciones'}`,
      cancel: 'Cancelar',
      warning: 'Esta accion no se puede deshacer.',
      quoteLabel: 'Cotizacion #',
    },
    toast: {
      created: 'Cotizacion creada exitosamente',
      updated: 'Cotizacion actualizada exitosamente',
      sent: 'Cotizacion enviada exitosamente',
      accepted: 'Cotizacion aceptada exitosamente',
      rejected: 'Cotizacion rechazada',
      converted: 'Cotizacion convertida exitosamente',
      reverted: 'Cotización revertida a abierta',
      voided: 'Cotizacion anulada exitosamente',
      bulkVoided: (count: number) =>
        `${count} ${count === 1 ? 'cotizacion anulada' : 'cotizaciones anuladas'} exitosamente`,
      discarded: 'Cambios descartados',
      lineItemAdded: 'Articulo agregado',
      lineItemUpdated: 'Articulo actualizado',
      lineItemDeleted: 'Articulo eliminado',
      createError: (error: string) => `Error al crear la cotizacion: ${error}`,
      updateError: (error: string) =>
        `Error al actualizar la cotizacion: ${error}`,
      sendError: (error: string) => `Error al enviar la cotizacion: ${error}`,
      acceptError: (error: string) =>
        `Error al aceptar la cotizacion: ${error}`,
      rejectError: (error: string) =>
        `Error al rechazar la cotizacion: ${error}`,
      convertError: (error: string) =>
        `Error al convertir la cotizacion: ${error}`,
      voidError: (error: string) => `Error al anular la cotizacion: ${error}`,
      lineItemError: (error: string) =>
        `Error al guardar el articulo: ${error}`,
      lineItemDeleteError: (error: string) =>
        `Error al eliminar el articulo: ${error}`,
      materialRequired: 'Por favor selecciona un material para cada articulo',
      cloned: (count: number) =>
        `Cotizacion clonada a ${count} ${count === 1 ? 'cuenta' : 'cuentas'} exitosamente`,
      cloneError: (error: string) => `Error al clonar la cotizacion: ${error}`,
      restored: 'Cotizacion restaurada exitosamente',
      restoreError: (error: string) =>
        `Error al restaurar la cotizacion: ${error}`,
    },
    validation: {
      selectAccount: 'Por favor selecciona una cuenta',
    },
  },
};
